module.exports = __webpack_public_path__ + "img/arthurthumb.fb6afd02.png";